<div class="product-box">
  <a [routerLink]="thumbnail.safeProductUrl" title="{{thumbnail.title}}">
    <div class="product-image">
      <img [src]="thumbnail.safeImageUrl" [alt]="thumbnail.title" [appImgSrcSet]="thumbnail.originalImageUrl" sizes="250px" [attr.loading]="loading" />
      <div class="product-masking">
      </div>
    </div>
  </a>
  <div class="product-caption">
    <a [routerLink]="thumbnail.safeProductUrl" title="{{thumbnail.title}}">
      <h5>{{thumbnail.title}}</h5>
    </a>
    <div class="row">
      <div class="col">
        @if (thumbnail.metadata.saleActive) {
          <div class="price">
            <span class="standard-price">{{thumbnail.formattedStandardPrice}}</span>
            <span class="sale-price"> {{thumbnail.formattedPrice}}</span>
          </div>
        }
        @if (!thumbnail.metadata.saleActive) {
          <div class="price">
            <div>{{thumbnail.formattedPrice}}</div>
          </div>
        }
      </div>
      <div class="favourites">
        @if (!favouritesService.favouritesMap[thumbnail.code]) {
          <a id="add-to-favourites-{{index}}"
            (click)="addToFavourites()">
            <i class="far fa-heart"></i>
          </a>
        }
        @if (favouritesService.favouritesMap[thumbnail.code]) {
          <a id="remove-from-favourites-{{index}}"
            (click)="removeFromFavourites()">
            <i class="fas fa-heart"></i>
          </a>
        }
      </div>
    </div>
  </div>
</div>